<template>
    <v-menu offset-y v-bind="{transition,openOnHover}">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="secondary"
                v-on="on"
                fab
                v-bind="{outlined,small,dark,top,bottom,right,left,absolute,fixed,}"
                >
                {{lang}}
            </v-btn>
        </template>
        <v-list>
            <v-list-item
                v-for="locale in locales"
                :key="locale"
                v-bind="{small,color:secondaryColor,dark:secondaryDark,class:secondaryClass}"
                v-if="lang!==locale"
                @click="setLang(locale)"
                >
                <v-list-item-title>{{ locale }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>
<script>
    export default {
        name: "SelectLocale",
        props: {
            locales:{type:Array,default(){return window.Localization.availableLocales();}},
            color:{default:'primary'},
            secondaryColor:{},
            secondaryDark:{},
            secondaryClass:{},
            small:{default:true},
            dark:{default:true},
            outlined:{default:true},

            absolute:{default:false,},
            fixed:{default:false,},
            top:{default:false,},
            bottom:{default:false,},
            right:{default:false,},
            left:{default:false,},

            openOnHover:{default:false,},
            transition:{},
        },
        data() {
            return {
                loading:false,
                opened:false,
            }
        },
        mounted() {
        },
        computed: {
            lang:{
                get(){return document.documentElement.lang;},
                set(lang){
                    this.setLang(lang)
                }
            },
            label(){return this.lang},
        },
        methods: {
            setLang(lang){
                this.loading=true;
                if(lang!==this.lang)
                    axios.get(`/locale/${lang}`)
                        .then(r=>{location = location.href;})
                        .catch(e=>console.error(e))
                        .finally(()=>{this.loading=false});
            },
            open(){this.opened=true;},

        },

        components: {},
        filters: {}
    }
</script>
